<template>
  <section v-if="isGetRequestPending" class="edit-drawing">
    <p-loading />
  </section>
  <section v-else class="edit-drawing">
    <header>
      <h1>Edit Workflow</h1>
    </header>
    <p-edit-form :is-request-pending="isUpdateRequestPending" :is-request-failed="isUpdateRequestFailed" :item="item" @submit="update" />
    <footer></footer>
  </section>
</template>

<script>
import { mapState } from 'vuex';
import CreateOrEditForm from './_CreateOrEdit';
import Loading from '@/components/common/Loading';

export default {
  components: {
    'p-edit-form': CreateOrEditForm,
    'p-loading': Loading
  },
  computed: {
    ...mapState({
      item: s => s.workflows.item,
      isGetRequestPending: s => s.workflows.isGetRequestPending,
      isUpdateRequestPending: s => s.workflows.isUpdateRequestPending,
      isUpdateRequestFailed: s => s.workflows.isUpdateRequestFailed
    })
  },
  watch: {
    '$route.params': {
      handler() {
        this.$store.dispatch('workflows/getById', this.$route.params.id);
      },
      immediate: true
    }
  },
  methods: {
    async update(data) {
      try {
        await this.$store.dispatch('workflows/update', { ...data, id: this.$route.params.id });

        this.$toast.success({
          title: 'Update completed',
          message: `Workflow was updated.`
        });
        this.$router.push({ path: `/workflows/` });
      } catch (e) {
        const response = await e.response.json();

        this.$toast.error({
          title: 'Update failed',
          message: `Reason: ${response.message}`
        });
      }
    },
    async confirmDelete() {
      const { id, name } = this.item;

      const confirmResult = await this.$confirm({
        title: 'Delete drawing?',
        message: `Are you sure you want to delete drawing '${name}'?\n\nThis action can't be undone.`,
        confirm: 'Delete'
      });

      if (!confirmResult) {
        return;
      }

      const lock = this.$lock();

      try {
        this.$toast.success({
          title: 'Drawing deleted',
          message: `Drawing '${name}' (${id}) was successfully deleted.`
        });
        this.$router.push({ path: `/workflows` });
      } catch (e) {
        this.$toast.error({
          title: 'Failed to delete drawing',
          message: `Please, try again later or contact our development team.`
        });
      } finally {
        lock.release();
      }
      await this.$store.dispatch('workflows/delete', id);
    }
  }
};
</script>

<style lang="scss" scoped>
.edit-drawing {
  display: grid;
  grid-gap: 0.5rem;
  grid-template-rows: minmax(0, max-content) minmax(0, 1fr);
  width: 100%;
  height: 100%;
  padding: 0 0.5rem 0 1rem;

  header {
    width: 100%;
    padding: 0.5rem 0.5rem 0 0;
    box-sizing: border-box;
    position: relative;
  }

  h1 {
    color: var(--theme-on-surface);
    font-size: 1.5rem;
    font-weight: 700;
  }

  .action-wrapper {
    position: absolute;
    right: 0rem;
    top: 50%;
    transform: translateY(-50%);
  }
}
</style>
